import React from 'react';
import RegisterScreen from '@/pages/Tooling/RegisterScreen';
import { DIE } from '@/pages/Tooling/toolings';

export default function DieRegisterPage() {
  return <RegisterScreen tooling={DIE} />;
}
